"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.style.list': 'Estilos de Escritura',
    'route.style.create': 'Agregar Estilo de Escritura',
    'route.style.edit': 'Editar Estilo de Escritura',
    'route.style.preview': 'Vista Previa del Estilo',
};
